var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fas fa-lock"}),_vm._v(" "+_vm._s(_vm.$t('Submission locked'))+"\n  "),_c('button',{staticClass:"btn btn-outline-dark btn-sm",on:{"click":_vm.openSubmission}},[_vm._v("\n    "+_vm._s(_vm.$t('Unlock'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }